import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  AdminApiPaths,
  APIDataProvider,
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api';
import { IGroupTutorRate } from '.';

export type TAdminCreateGroupTutorRate = {
  tutorCountry: string;
  courseType: string;
  minStudentCount: number;
  maxStudentCount: number;
  amounts: Array<{
    version: string;
    amount: number;
    currency: string;
  }>;
};

export type TAdminGetGroupTutorRates = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
  tutorCountry?: string;
  courseType?: string;
};

export type TAdminUpdateGroupTutorRate = {
  id: string;
  tutorCountry: string;
  courseType: string;
  minStudentCount: number;
  maxStudentCount: number;
  amounts: Array<{
    version: string;
    amount: number;
    currency: string;
  }>;
};

export type TAdminGetUserGroupTutorRates = {
  userId: string;
};

const apiDataProvider = new APIDataProvider();

const adminGetGroupTutorRatesModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
  tutorCountry,
  courseType,
}: TAdminGetGroupTutorRates) => {
  let path = `${AdminApiPaths.groupTutorRates}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  if (tutorCountry) {
    path += `&tutorCountry=${tutorCountry}`;
  }

  if (courseType) {
    path += `&courseType=${courseType}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IGroupTutorRate>>
  >(path);

  return response.data;
};

export const adminCreateGroupTutorRate = createAsyncThunk(
  '/admin/group-tutor-rates/create',
  async (data: TAdminCreateGroupTutorRate) => {
    const path = `${AdminApiPaths.groupTutorRates}`;

    const response = await apiDataProvider.post<TApiResponse<IGroupTutorRate>>(
      path,
      data
    );

    return response.data;
  }
);

export const adminUpdateGroupTutorRate = createAsyncThunk(
  '/admin/group-tutor-rates/update',
  async (data: TAdminUpdateGroupTutorRate) => {
    const path = `${AdminApiPaths.groupTutorRates}/${data.id}`;

    const response = await apiDataProvider.put<TApiResponse<IGroupTutorRate>>(
      path,
      data
    );

    return response.data;
  }
);

export const adminDeleteGroupTutorRate = createAsyncThunk(
  '/admin/group-tutor-rates/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.groupTutorRates}/${id}`;

    const response = await apiDataProvider.delete<
      TApiResponse<IGroupTutorRate>
    >(path);

    return response.data;
  }
);

export const getUserGroupTutorRatesAsAdmin = createAsyncThunk(
  '/admin/user/group-tutor-rates/user/list',
  async ({ userId }: TAdminGetUserGroupTutorRates) => {
    const path = `${AdminApiPaths.groupTutorRates}/user/${userId}?userId=${userId}`;

    const response = await apiDataProvider.get<TApiResponse<IGroupTutorRate[]>>(
      path
    );

    return response.data;
  }
);

export const adminGetGroupTutorRates = createAsyncThunk(
  '/admin/group-tutor-rates/list',
  adminGetGroupTutorRatesModule
);
